import Interaction from "../../../models/interactions/Interaction";
import { IStopWalking } from "../../../models/interactions/StopWalking";
import NodeActorDropdown from "../components/NodeActorDropdown";
import useUpdateSequenceInteraction from "./UpdateSequenceInteraction.hook";

export default function StopWalkingNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const interaction = props.interaction as IStopWalking;
  const { updateInteraction } = useUpdateSequenceInteraction();

  return (
    <div className="flex flex-col gap-[12px] w-full h-full">
      <NodeActorDropdown
        label="Actor"
        selectedActorId={interaction.npcId}
        onClick={(actorId) =>
          updateInteraction(props.nodeId, {
            ...interaction,
            npcId: actorId,
          } as IStopWalking)
        }
      />
    </div>
  );
}
